




































import Vue from 'vue';
import { defineComponent, ref, computed, onMounted } from '@vue/composition-api';

const componentName = 'wok-dialog-input';

export default defineComponent({
    name: componentName,

    props: {
        show: { 
            type: Boolean, 
            default: false 
        },
        cancelLabel: {
            type: String,
            default: undefined
        },
        confirmLabel: {
            type: String,
            default: undefined
        },
        value: {
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        confirmDisabled: {
            type: Boolean,
            default: false
        }
    },

    setup(props, context) {
        const currValue = ref(null);
        const inputFocus = ref(false);

        onMounted(() => {
            inputFocus.value = true;
        });

        const onInput = (evt) => {
            currValue.value = evt;
        }

        const onEmitInput = () => {
            context.emit('input', currValue.value);
        }

        const onRequestHideDialog = () => { 
            context.emit('hide-dialog'); 
        }

        return {
            onInput,
            onEmitInput,
            onRequestHideDialog,
            inputFocus
        }
    }
})
